import type { NameStatus, RatingRecord } from "./types";

export const deriveStatus = (
  mine: RatingRecord | undefined,
  partner: RatingRecord | undefined,
): NameStatus => {
  if (mine === undefined || partner === undefined) {
    return "Pending";
  }
  if (mine.score === -2 || partner.score === -2) {
    return "Declined";
  }
  if (mine.score <= 0 && partner.score <= 0) {
    return "Declined";
  }
  if (mine.score >= 1 && partner.score >= 1) {
    return "Match";
  }
  return "Mixed";
};

export const statusRank: Record<NameStatus, number> = {
  Match: 0,
  Pending: 1,
  Mixed: 2,
  Declined: 3,
};

export const isDisqualifiedByPartner = (
  partner: RatingRecord | undefined,
): boolean => partner?.score === -2;
